const TUS_FINGERPRINT_PREFIX = "mem-import";
const TUS_FINGERPRINT_SEPARATOR = "::";

export function generateImportTusFingerprint(params: {
  fileId: string;
  filename: string;
  fileSize: number | "unknown";
  endpoint: string;
}): string {
  return [
    TUS_FINGERPRINT_PREFIX,
    params.fileId,
    params.filename,
    params.fileSize,
    params.endpoint,
  ].join(TUS_FINGERPRINT_SEPARATOR);
}

export function constructBlobName(params: {
  spaceAccountId: string;
  fileId: string;
  filename: string;
}): string {
  return `${params.spaceAccountId}/${params.fileId}/${params.filename}`;
}
